// 👇 Third Party Components { Start
import { jsPDF } from "jspdf"
import { utils, writeFile } from 'xlsx'
import html2canvas from 'html2canvas'
import jwt_decode from 'jwt-decode'
// ☝ Third Party Components End }
import { DefaultRoute, HRDashboardRoute, AdminDashboardRoute, AnyDashboardRoute, LimitedDashboardRoute, ExternalDispatchRoute } from '../router/routes' // 👈️ DefaultRoute Imports
import CopyToClipboard from 'react-copy-to-clipboard'
import { Copy } from 'react-feather'
import toast from 'react-hot-toast'
import moment from "moment/moment"
import { TaskTimer } from 'tasktimer'
import Avatar from '@components/avatar'
import { urlAzureBlobServices, urlAuthService } from '@src/endpoints'
import defaultAvatar from '@src/assets/images/portrait/small/avatar.png'
import { CheckContainerNumberPerIsoSD } from "./ContainerNumberUtils"
import { matchesBookingTeam } from './bookingTeamRoles' //US 11866
import axios from 'axios'
import ExcelJS from 'exceljs'

const weightWithCommas = x => {
  return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const weightFormat = num => { return `${weightWithCommas(num)}` }

const imageExists = (image_url) => {
  const http = new XMLHttpRequest()
  http.open('HEAD', image_url, false)
  http.send()
  return http.status !== 404
}

// 👇 Converts Weight to KG - Upload Schedule
export const convertWeightToKG = (weight, unit) => {
  if (unit && typeof weight === 'number') {
    let newWeight = weight
    if (unit === 'LBS') {
      newWeight = weight * 0.453592
    } else if (unit === 'MT') {
      newWeight = weight * 1000
    }
    return newWeight
  }
  return null
}

// 👇 Renders Client Columns
export const renderUserAvatar = avatar => {
  const image_url = `${urlAzureBlobServices}/${avatar}`
  if (avatar?.length && avatar?.includes('.') && imageExists(image_url)) {
    return <Avatar className='me-1' img={image_url} width='32' height='32' />
  } else {
    return (
      <Avatar className='me-1' img={defaultAvatar} width='32' height='32' />
    )
  }
}
// phone number validation
export const validatePhoneNumber = (value) => {
  if (!value) {
    return 'Phone number is required'
  }

  // Remove non-numeric characters
  const numericValue = value.replace(/\D/g, '')

  // Check if the numeric value has exactly 10 digits
  return numericValue.length === 10 ? true : 'Please enter a 10-Digit valid phone number'
}

// 👇 Renders Client Columns
export const renderVesselCountry = flag => {
  const image_url = `https://www.worldatlas.com/r/w425/img/flag/${flag?.toLowerCase()}-flag.jpg`
  if (flag?.length && image_url?.includes('.')) {
    return <Avatar className='me-1' img={image_url} width='32' height='32' />
  } else {
    return (
      <Avatar className='me-1' img={defaultAvatar} width='32' height='32' />
      //<Avatar className='me-1' img={image_url} width='32' height='32' />
    )
  }
}

export const isObjEmpty = obj => Object.keys(obj).length === 0 // 👈️ Checks if an object is empty (returns boolean)
export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num) // 👈️ Returns K format from a number
export const htmlToString = html => html.replace(/<\/?[^>]+(>|$)/g, '') // 👈️ Converts HTML to string

String.prototype.minsToHHMMSS = function () {
  const mins_num = parseFloat(this, 10) // don't forget the second param
  let hours = Math.floor(mins_num / 60)
  let minutes = Math.floor((mins_num - (((hours * 3600)) / 60)))
  let seconds = Math.floor((mins_num * 60) - (hours * 3600) - (minutes * 60))

  // Appends 0 when unit is less than 10
  if (hours < 10) { hours = `0${hours}` }
  if (minutes < 10) { minutes = `0${minutes}` }
  if (seconds < 10) { seconds = `0${seconds}` }
  return `${hours}:${minutes}:${seconds}`
}

/*
//Function to convert minuted to HH:MM:SS format
export const minsToHHMMSS = (mins) => {
  const hours = Math.floor(mins / 60)
  const minutes = Math.floor(mins % 60)
  const seconds = 0
  return `${hours}:${minutes}:${seconds}`
}

*/

String.prototype.minsTohrm = function () {
  const mins_num = parseFloat(this, 10) // don't forget the second param
  const hours = Math.floor(mins_num / 60)
  const minutes = Math.floor((mins_num - (((hours * 3600)) / 60)))
  return hours === 0 ? `${minutes} min` : `${hours} hrs ${minutes} min`
}

String.prototype.minsTohr = function () {
  const mins_num = parseFloat(this, 10) // don't forget the second param
  let hours = Math.floor(mins_num / 60)
  let minutes = Math.floor((mins_num - (((hours * 3600)) / 60)))
  if (hours < 10) { hours = `0${hours}` }
  if (minutes < 10) { minutes = `0${minutes}` }
  return hours === 0 ? `0.${minutes}` : `${hours}.${minutes}`
}

const isToday = date => { // 👈️ Checks if the passed date is today
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

// const twoDigitFormat = data => { // 👈️ Convert date/month single digit to two digit
//   return `0${data}`.slice(-2)
// }

export const twoDigitFormat = data => { // 👈️ Convert date/month single digit to two digit
  return `0${data}`.slice(-2)
}

export const getDateOnly = (date, type) => { // 👈️ Convert actual date format
  if (date !== undefined && date !== null) {
    const dateOnly = date?.split(type)[0]
    return dateOnly
  } else {
    return null
  }
}

//getDateOnly v2, date-month-year, eg: 07-May-2023
export const getDateOnlyV2 = (date) => { // 👈️ Convert actual date format
  if (date !== undefined && date !== null) {
    const dateObj = new Date(date)
    if (isNaN(dateObj.getTime())) {
      console.warn('Invalid date provided to getDateOnlyV2:', date)
      return null
    }
    const year = dateObj.getFullYear()
    const month = dateObj.toLocaleString('default', { month: 'short' })
    const day = dateObj.getDate().toString().padStart(2, '0')
    return `${day}-${month}-${year}`
  } else {
    return null
  }
}
export const getLocalDate = (date) => {
  // Convert UTC date to local browser timezone date, handling date shifts
  if (date !== undefined && date !== null) {
    try {
      // Create Date object from input (assuming it's in UTC if no Z is present)
      const utcDateString = date.endsWith('Z') ? date : `${date}Z`
      const dateObj = new Date(utcDateString)

      // Verify the date is valid
      if (isNaN(dateObj.getTime())) {
        console.warn('Invalid date provided to getDateOnly:', date)
        return null
      }

      // Get year, month, and day in local browser timezone
      // No need for explicit conversion - Date methods already use local timezone
      const year = dateObj.getFullYear()
      const month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
      const day = dateObj.getDate().toString().padStart(2, '0')

      // Return formatted date
      return `${year}-${month}-${day}`

    } catch (error) {
      console.error('Error in getDateOnly:', error)
      return null
    }
  }
  return null
}
export const getTimeOnly = (date, type) => { // 👈️ Convert actual Time format
  if (date !== undefined && date !== null) {
    let timeOnly = date.split(type)[1]
    timeOnly = timeOnly.includes('.') ? timeOnly.split('.')[0] : timeOnly
    return timeOnly
  } else {
    return null
  }
}

export const getLocalTime = (date) => {
  if (date !== undefined && date !== null) {
    try {
      const utcDateString = date.endsWith('Z') ? date : `${date}Z`
      const dateObj = new Date(utcDateString)
      if (isNaN(dateObj.getTime())) {
        console.warn('Invalid date provided to getTimeOnly:', date)
        return null
      }
      return dateObj.toLocaleTimeString('en-US', {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
      })
    } catch (error) {
      console.error('Error in getTimeOnly:', error)
      return null
    }
  }
  return null
}
export const getNoOfMinutes = (start, end) => { // 👈️ Convert actual hours
  if (start === null || end === null) return null
  const startDate = moment(start).valueOf()
  const endDate = moment(end).valueOf()
  const minutes = Math.floor(((endDate - startDate) / (1000 * 60)))
  return minutes
}

export const getNoOfHours = (start, end) => { // 👈️ Convert actual hours
  if (start === null || end === null) return null
  const startDate = moment(start).valueOf()
  const endDate = moment(end).valueOf()
  const hours = ((endDate - startDate) / (1000 * 60 * 60)).toFixed(2)
  return hours
}

export const getHHMMSS = (start, end) => { // 👈️ Convert actual hours
  if (start === null || end === null) return null
  const startDate = moment(start).valueOf()
  const endDate = moment(end).valueOf()
  const minutes = ((endDate - startDate) / (1000 * 60))
  return minutes.toString().minsToHHMMSS()
}

export const getHrForChart = (start, end) => { // 👈️ Convert actual hours
  if (start === null || end === null) return null
  const startDate = moment(start).valueOf()
  const endDate = moment(end).valueOf()
  const minutes = ((endDate - startDate) / (1000 * 60))
  let chartPercent = minutes.toString().minsTohr() * 12.05 // 12.05 is used for adjusting 08hr 30m to 100% in chart
  chartPercent = chartPercent.toString().includes('.') ? chartPercent.toString().split('.')[0] : chartPercent
  return chartPercent > 0 ? chartPercent : 0
}

export const getHMSAddMin = (start, end, addMin) => { // 👈️ Convert actual hours
  if (start === null || end === null) return null
  addMin = (addMin === undefined || null) ? 0 : addMin
  const startDate = moment(start).valueOf()
  const endDate = moment(end).valueOf()
  const minutes = ((endDate - startDate) / (1000 * 60)) + addMin
  return minutes.toString().minsToHHMMSS()
}

export const getSeconds = (start, end) => { // 👈️ Get seconds
  if (start === null || end === null) return null
  const startDate = moment(start).valueOf()
  const endDate = moment(end).valueOf()
  const seconds = ((endDate - startDate) / (1000))
  return seconds
}

export const getHrFromMin = (minutes) => { // 👈️ Convert actual hours
  if (minutes === null) return '00:00:00'
  return minutes.toString().minsToHHMMSS()
}

export const getHrmFromMin = (minutes) => { // 👈️ Convert actual hours
  if (minutes === null) return '0 min'
  return minutes.toString().minsTohrm()
}

export const getConvertedHours = (hoursMins) => { // 👈️ Convert actual hours
  if (hoursMins === null) return '00:00:00'
  const hours = hoursMins.split(':')[0]
  const mins = hoursMins.split(':')[1]
  const convertedHours = ((60 * hours) + (mins * 1)) / (60)
  return convertedHours.toFixed(2)
}

export const getConvertedHoursNumber = (hoursMins) => {
  if (!hoursMins) return ''
  const time = hoursMins.toString()

  if (!time.includes(':')) {
    const decimalHours = parseFloat(time)

    return Number.isNaN(decimalHours) ? '' : Number(decimalHours.toFixed(2))
  }

  const [hours = 0, mins = 0] = time.split('.')[0].split(':')
  const parsedHours = parseFloat(hours)
  const parsedMins = parseFloat(mins)
  const convertedHours = ((60 * parsedHours) + parsedMins) / 60

  return Number.isNaN(convertedHours) ? '' : Number(convertedHours.toFixed(2))
}

export const treatAsUTC = (date) => {
  const result = new Date(date)
  result.setMinutes(result.getMinutes() - result.getTimezoneOffset())
  return result
}

export const noOfDays = (start, end) => {
  const millisecondsPerDay = 24 * 60 * 60 * 1000
  const milliseconds = 60 * 60 * 1000
  let day = Math.ceil((treatAsUTC(end) - treatAsUTC(start)) / millisecondsPerDay)
  const hours = Math.ceil((treatAsUTC(end) - treatAsUTC(start)) / milliseconds)
  day = day > 1 ? `${day} Days` : hours > 7 ? '1 Day' : `${hours} Hours`
  return day
}

export const getBusinessDays = (startDate, endDate) => {
  const weekends = new Set([0, 6]) // Sunday (0) and Saturday (6) are considered weekends
  const millisecondsPerDay = 24 * 60 * 60 * 1000
  let businessDays = 0

  const currentDate = new Date(startDate)
  const endDateTime = new Date(endDate)

  while (currentDate <= endDateTime) {
    if (!weekends.has(currentDate.getDay())) {
      businessDays++
    }

    currentDate.setTime(currentDate.getTime() + millisecondsPerDay)
  }

  return businessDays
}

export const countWorkingDays = (startDate, endDate) => {
  // Calculate the difference in hours
  const timeDifference = Math.abs(new Date(endDate) - new Date(startDate))
  const hoursDifference = timeDifference / (1000 * 60 * 60)

  // If less than 10 hours, return in hours
  if (hoursDifference < 10) {
    const hours = Math.ceil(hoursDifference)
    return hours === 1 ? '1 Hour' : `${hours} Hours`
  }

  // Otherwise, return in business days
  const businessDays = getBusinessDays(startDate, endDate)
  const workingDays = businessDays > 1 ? `${businessDays} Days` : '1 Day'

  return workingDays
}

// ** Renders WorkDone Columns
export const displayHoursWorked = (start) => {
  return getHHMMSS(start, new Date().toLocaleString('en-US', { hour12: true }))
}

export const getHRM = (start, end) => { // 👈️ Convert actual hours
  if (start === null || end === null) return null
  const startDate = moment(start).valueOf()
  const endDate = moment(end).valueOf()
  const minutes = ((endDate - startDate) / (1000 * 60))
  return minutes.toString().minsTohrm()
}

export const getBurnOut = (start, end) => { // 👈️ Convert actual hours
  if (start === null || end === null) return null
  const startDate = moment(start).valueOf()
  const endDate = moment(end).valueOf()
  const diff = endDate - startDate
  const burnOut = (diff / (1000 * 60 * 60))
  return Math.floor(burnOut * 10)
}

export const getBurnOutColor = (start, end) => { // 👈️ Convert actual hours
  if (start === null || end === null) return null
  const startDate = moment(start).valueOf()
  const endDate = moment(end).valueOf()
  const burnOut = ((endDate - startDate) / (100 * 60 * 60)).toFixed(2)
  if (burnOut <= 25) {
    return 'progress-bar-info'
  } else if (burnOut <= 50) {
    return 'progress-bar-purple'
  } else if (burnOut <= 75) {
    return 'progress-bar-warning'
  } else if (burnOut <= 90) {
    return 'progress-bar-success'
  } else if (burnOut > 90) {
    return 'progress-bar-primary'
  }
}

export const getBurnOutColorByHour = (hours) => { // 👈️ Convert actual hours
  if (hours === null) return null
  if (hours <= 25.0) {
    return 'progress-bar-info'
  } else if (hours <= 50.0) {
    return 'progress-bar-purple'
  } else if (hours <= 75.0) {
    return 'progress-bar-warning'
  } else if (hours <= 90.0) {
    return 'progress-bar-success'
  } else if (hours > 90.0) {
    return 'progress-bar-primary'
  }
}


export const getBurnOutColorByContribution = (contribution) => { // 👈️ Convert actual hours
  if (contribution === null) return null
  if (contribution <= 5000) {
    return 'progress-bar-info'
  } else if (contribution <= 6000) {
    return 'progress-bar-purple'
  } else if (contribution <= 7000) {
    return 'progress-bar-warning'
  } else if (contribution <= 8000) {
    return 'progress-bar-success'
  } else if (contribution > 9000) {
    return 'progress-bar-primary'
  }
}

// export const getDateOnly = (date) => { // 👈️ Convert UTC Date to Local Date format
//   if (date !== undefined && date !== null) {
//     const offset = new Date().getTimezoneOffset()
//     const utcDateTime = new Date(date)
//     utcDateTime.setHours(utcDateTime.getHours() - (offset / 60))
//     const pstDateTime = new Date(utcDateTime)

//     const displayDate = `${pstDateTime.getFullYear()}-${twoDigitFormat(pstDateTime.getMonth() + 1)}-${twoDigitFormat(pstDateTime.getDate())}`
//     return displayDate
//   } else {
//     return null
//   }
// }

// export const getDateTime = (date) => {
//   if (date !== undefined && date !== null) {
//     const offset = new Date().getTimezoneOffset()
//     const utcDateTime = new Date(date)
//     utcDateTime.setHours(utcDateTime.getHours() - (offset / 60))
//     const pstDateTime = new Date(utcDateTime)
//     let formattedTime = pstDateTime.toString().split(' ')[4]
//     const hour = parseInt(formattedTime.split(':')[0])
//     if (hour === 0) {
//       formattedTime = `12:${formattedTime.split(':')[1]} AM`
//     } else if (hour >= 12) {
//       formattedTime = `${hour - 12}:${formattedTime.split(':')[1]} PM`
//     } else {
//       formattedTime = `${hour}:${formattedTime.split(':')[1]} AM`
//     }
//     const displayDateTime = `${pstDateTime.getFullYear()}-${twoDigitFormat(pstDateTime.getMonth() + 1)}-${twoDigitFormat(pstDateTime.getDate())} ${formattedTime}`
//     return displayDateTime
//   } else {
//     return null
//   }
// }
// function to convert date to ISO format
export const toISOString = (date) => {
  if (date instanceof Date) {
    return date.toISOString()
  } else if (typeof date === 'string') {
    return new Date(date).toISOString()
  }
  return null
}
const twooDigitFormat = (num) => num.toString().padStart(2, '0')

export const getDateTime = (date) => {
  //condition to check if date is null or undefined or empty string or invalid date
  if (date === undefined || date === null || date === '' || (date instanceof Date && isNaN(date.getTime())) || (typeof date === 'string' && isNaN(new Date(date).getTime()))) {
    return ''
  }
  if (date !== undefined && date !== null) {
    // Check if date is already a Date object
    const dateObj = date instanceof Date ? date : new Date(date)
    // If it's a string, we can try to ensure UTC format
    let utcDate
    if (typeof date === 'string') {
      utcDate = new Date(date.endsWith('Z') ? date : `${date}Z`)
    } else {
      utcDate = dateObj
    }
    // Get date components directly 
    const year = utcDate.getFullYear()
    const month = twooDigitFormat(utcDate.getMonth() + 1)
    const day = twooDigitFormat(utcDate.getDate())
    const hours = utcDate.getHours()
    const minutes = twooDigitFormat(utcDate.getMinutes())
    const ampm = hours >= 12 ? 'PM' : 'AM'
    const formattedHours = twooDigitFormat(hours % 12 || 12)

    // Construct the display date-time string
    const displayDateTime = `${year}-${month}-${day} ${formattedHours}:${minutes} ${ampm}`

    return displayDateTime
  } else {
    return null
  }
}
//uses moment.js to get date time
export const getDateTimev2 = (date) => {
  if (date === undefined || date === null || date === '' || (date instanceof Date && isNaN(date.getTime())) || (typeof date === 'string' && isNaN(new Date(date).getTime()))) {
    return ''
  }
  if (date !== undefined && date !== null) {
    // Check if date is already a Date object
    const dateObj = date instanceof Date ? date : new Date(date)
    // Get date components using moment.js
    const formattedDateTime = moment(dateObj).format('YYYY-MM-DD hh:mm A')
    return formattedDateTime
  } else {
    return null
  }
}

export const getLocalDateTime = (date) => { // 👈️ Convert UTC date to Local DateTime format
  try {
    // Check for null, undefined, empty string, or invalid date types
    if (date === null || date === undefined || date === '' || 
        (typeof date !== 'string' && typeof date !== 'number' && !(date instanceof Date))) {
      return null
    }

    // Handle already formatted strings that might not be valid dates
    if (typeof date === 'string') {
      // Check for empty or whitespace-only strings
      if (date.trim() === '') {
        return null
      }
      
      // Check for obviously invalid date formats
      if (date === 'Invalid Date' || date === 'NaN' || date === 'null' || date === 'undefined') {
        return null
      }
    }

    // Ensure ISO datetime strings without timezone indicator are treated as UTC
    // Without 'Z', new Date() treats the string as local time, breaking the UTC→PST conversion
    let dateInput = date
    if (typeof date === 'string' && date.includes('T') && !date.endsWith('Z') && !/[+-]\d{2}:\d{2}$/.test(date)) {
      dateInput = `${date}Z`
    }

    const utcDateTime = new Date(dateInput)

    // Check if the date is invalid using multiple methods
    if (isNaN(utcDateTime) || isNaN(utcDateTime.getTime()) || utcDateTime.toString() === 'Invalid Date') {
      console.warn('Invalid date provided to getLocalDateTime:', date)
      return null
    }

    // Additional validation to ensure the date is within reasonable bounds
    const dateYear = utcDateTime.getFullYear()
    if (dateYear < 1900 || dateYear > 2100) {
      console.warn('Date year out of reasonable range in getLocalDateTime:', date)
      return null
    }

    let formatter
    try {
      formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Los_Angeles', // PST/PDT Timezone
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true // 👈️ 12 hour format with AM/PM
      })
    } catch (error) {
      console.error('Error creating DateTimeFormat in getLocalDateTime:', error)
      return null
    }

    let formattedDate
    try {
      formattedDate = formatter.format(utcDateTime)
    } catch (error) {
      console.error('Error formatting date in getLocalDateTime:', error)
      return null
    }

    // Null check for formattedDate before using regex
    if (!formattedDate || typeof formattedDate !== 'string') {
      console.warn('Formatted date is invalid in getLocalDateTime:', formattedDate)
      return null
    }

    // Use a more robust regex pattern and add null checks
    const regexMatch = formattedDate.match(/(\d{2})\/(\d{2})\/(\d{4}), (\d{1,2}:\d{2} (AM|PM))/)
    
    if (!regexMatch || regexMatch.length < 5) {
      console.warn('Regex match failed for formatted date in getLocalDateTime:', formattedDate)
      return null
    }

    const [, month, day, year, time] = regexMatch

    // Validate extracted components
    if (!month || !day || !year || !time) {
      console.warn('Date components extraction failed in getLocalDateTime:', { month, day, year, time })
      return null
    }

    return `${year}-${month}-${day}T${time}`
  } catch (error) {
    console.error('Unexpected error in getLocalDateTime:', error, 'Input:', date)
    return null
  }
}

export const getLocalDateOnly = (date, type) => { // 👈️ Convert actual date format
  try {
    // Initial comprehensive null/undefined checks
    if (date === null || date === undefined || date === '' || 
        (typeof date !== 'string' && typeof date !== 'number' && !(date instanceof Date))) {
      return null
    }

    // Validate type parameter early
    if (!type || typeof type !== 'string' || type.trim() === '') {
      console.warn('Invalid or empty type parameter provided to getLocalDateOnly:', type)
      return null
    }

    // Call getLocalDateTime and check result
    const localDate = getLocalDateTime(date)
    
    // Comprehensive null checks for getLocalDateTime result
    if (localDate === null || localDate === undefined || localDate === '') {
      console.warn('getLocalDateTime returned null/undefined/empty for date:', date)
      return null
    }
    
    // Type validation for localDate
    if (typeof localDate !== 'string') {
      console.warn('getLocalDateTime returned non-string value:', localDate, 'for date:', date)
      return null
    }

    // Check if localDate contains the separator
    if (!localDate.includes(type)) {
      console.warn('LocalDate does not contain separator type:', type, 'in localDate:', localDate)
      return null
    }
    
    // Safe split operation
    const splitResult = localDate.split(type)
    if (!splitResult || splitResult.length === 0) {
      console.warn('Split operation failed for localDate:', localDate, 'with type:', type)
      return null
    }

    const dateOnly = splitResult[0]
    
    // Final validation of result
    if (!dateOnly || typeof dateOnly !== 'string' || dateOnly.trim() === '') {
      console.warn('Extracted dateOnly is invalid:', dateOnly)
      return null
    }
    
    return dateOnly.trim()
    
  } catch (error) {
    console.error('Unexpected error in getLocalDateOnly:', error, 'Input date:', date, 'Type:', type)
    return null
  }
}

export const getLocalTimeOnly = (date, type) => { // 👈️ Convert actual Time format
  try {
    // Initial comprehensive null/undefined checks
    if (date === null || date === undefined || date === '' || 
        (typeof date !== 'string' && typeof date !== 'number' && !(date instanceof Date))) {
      return null
    }

    // Validate type parameter early
    if (!type || typeof type !== 'string' || type.trim() === '') {
      console.warn('Invalid or empty type parameter provided to getLocalTimeOnly:', type)
      return null
    }

    // Call getLocalDateTime and check result
    const localDate = getLocalDateTime(date)
    
    // Comprehensive null checks for getLocalDateTime result
    if (localDate === null || localDate === undefined || localDate === '') {
      console.warn('getLocalDateTime returned null/undefined/empty for date:', date)
      return null
    }
    
    // Type validation for localDate
    if (typeof localDate !== 'string') {
      console.warn('getLocalDateTime returned non-string value:', localDate, 'for date:', date)
      return null
    }

    // Check if localDate contains the separator
    if (!localDate.includes(type)) {
      console.warn('LocalDate does not contain separator type:', type, 'in localDate:', localDate)
      return null
    }
    
    // Safe split operation
    const splitResult = localDate.split(type)
    if (!splitResult || splitResult.length < 2) {
      console.warn('Split operation failed or insufficient parts for localDate:', localDate, 'with type:', type)
      return null
    }

    const timeOnly = splitResult[1]
    
    // Final validation of result
    if (!timeOnly || typeof timeOnly !== 'string' || timeOnly.trim() === '') {
      console.warn('Extracted timeOnly is invalid:', timeOnly)
      return null
    }
    
    return timeOnly.trim()
    
  } catch (error) {
    console.error('Unexpected error in getLocalTimeOnly:', error, 'Input date:', date, 'Type:', type)
    return null
  }
}

export const formatLocalDateTime = (date) => { // 👈️ Format local DateTime to readable format
  if (date !== undefined && date !== null) {
    const localDate = new Date(date)
    const year = localDate.getFullYear()
    const month = String(localDate.getMonth() + 1).padStart(2, '0')
    const day = String(localDate.getDate()).padStart(2, '0')
    const hours = localDate.getHours()
    const minutes = String(localDate.getMinutes()).padStart(2, '0')
    const ampm = hours >= 12 ? 'PM' : 'AM'
    const formattedHours = hours % 12 || 12
    const formattedDate = `${year}-${month}-${day}`
    const formattedTime = `${formattedHours}:${minutes} ${ampm}`
    return `${formattedDate} ${formattedTime}`
  } else {
    return null
  }
}

export const getShortFormatDate = date => { // 👈️ Convert to short date format (YYYY-MM-DD)
  const result = `${date?.getFullYear()}-${twoDigitFormat(date?.getMonth() + 1)}-${twoDigitFormat(date?.getDate())}`
  return result
}

export const getFileNameFromDate = () => { // 👈️ Convert to short date format (YYYY-MM-DD)
  const date = new Date()
  const result = `${date?.getFullYear()}_${date?.getMonth() + 1}_${date?.getDate()}_${date?.getHours()}${date?.getMinutes()}${date.getSeconds()}`
  return result
}

// Timer with 1000ms (1 second) base interval resolution.
const timer = new TaskTimer(1000)
let timer_id = 1000
// interval can be updated anytime by setting the `timer.interval` property.
export const addTimer = (_id, start, minutes) => {
  timer_id = timer_id + 1
  if (start !== null) {
    timer.add([
      {
        id: timer_id,       // unique ID of the task
        tickInterval: 1,    // run every 5 ticks (5 x interval = 5000 ms)
        totalRuns: 0,      // run 10 times only. (set to 0 for unlimited times)
        callback() {
          // code to be executed on each run
          //console.log(`${task.id    flag = flag.split('    flag = flag.split(' ').pop() true })))
          document.getElementById(_id).innerHTML = getHMSAddMin(start, new Date().toLocaleString('en-US', { hour12: true }), minutes)
        }
      }
    ])
    // Start the timer
    timer.start()
  }
}

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) => {
  if (!value) return value
  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatTime = (value, formatting = { hour: 'numeric', minute: 'numeric' }) => {
  if (!value) return value
  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

export const formatTime12H = (value, formatting = { hour: 'numeric', minute: 'numeric', hour12: true }) => {
  if (!value) return value
  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value)).toLowerCase()
}

export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => { // 👈️ Returns short month of passed date
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric' }
  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  } return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

export const createPDF = (data, fileName, width, height) => { // 👈️ Create PDF file from JSON data
  const jsPdf = new jsPDF('landscape', "px", [width, height])
  const headers = Object.keys(data[0])
  jsPdf.table(1, 1, data, headers, { autoSize: true })
  jsPdf.save(fileName)
}

const convertArrayOfObjectsToCSV = (data) => { // 👈️ Converts table to CSV
  let result
  const columnDelimiter = ','
  const lineDelimiter = '\n'
  const keys = Object.keys(data[0])
  result = ''
  result += keys.join(columnDelimiter)
  result += lineDelimiter
  data.forEach(item => {
    let ctr = 0
    keys.forEach(key => {
      if (ctr > 0) result += columnDelimiter
      result += item[key]
      ctr++
    })
    result += lineDelimiter
  })
  return result
}

export const createCSV = (data, fileName) => { // 👈️ Create CSV file from JSON data
  const link = document.createElement('a')
  let csv = convertArrayOfObjectsToCSV(data)
  if (csv === null) return
  if (!csv.match(/^data:text\/csv/i)) {
    csv = `data:text/csvcharset=utf-8,${csv}`
  }
  link.setAttribute('href', encodeURI(csv))
  link.setAttribute('download', fileName)
  link.click()
}

export const createExcel = (data, fileName, isAOA) => { // 👈️ Create Excel file from JSON data
  const ws = isAOA ? utils.aoa_to_sheet(data) : utils.json_to_sheet(data)
  const wb = utils.book_new()
  const wsName = fileName.includes('_') ? fileName.split('_')[0] : fileName // 👈️ Split file name into readable format
  utils.book_append_sheet(wb, ws, wsName)
  writeFile(wb, fileName)// 👈️ generate XLSX file and send to client
}

export const convertJsonToAoa = (headers, data) => {
  const headersData = headers.map((d) => d.label)
  const rows = data.map((d) => headers.map((h) => d[h.key] || ''))
  return [headersData, ...rows]
}

export const JSONParse = (data) => { // 👈️ Convert to string and Parse to JSON data
  const stringData = JSON.parse(JSON.stringify(data, (key, value) => (typeof (value) === 'number' ? `${value}` : value)))
  return JSON.parse(JSON.stringify(stringData, (key, value) => (value === null ? 'N/A' : value)))
}

export const countryFlag = (img) => {  // 👈️ Get Country Flag
  if ((img !== null && img !== undefined && img !== 'N/A')) {
    let flag = img.match(/\(([^)]+)\)$/)?.[1] || img   // Regular expression to match the last set of parentheses and extract the content inside
    flag = flag.split(' ').pop()
    const imgPath = `https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/${flag.toLowerCase().substring(0, 2)}.svg`
    return imgPath
  }
  return ''
}

export const getLabel = (arr, value) => {  // 👈️ Get Label from DD List
  if (Array.isArray(arr) && value !== null && value !== undefined) {
    return arr[arr.findIndex(obj => obj.value.toString() === value.toString())]?.label
  } else {
    return 'N/A'
  }
}

export const getLabelText = (arr, label, title) => { // 👈️ Get Label from DD List passing Title
  if (Array.isArray(arr) && label !== null && label !== undefined && label !== '') {
    return arr[arr.findIndex(obj => obj.label.toString() === label.toString())]?.label
  } else {
    return title
  }
}

export const getFFstatus = (status) => { // 👈️ Get FF Status
  if (status === 'Rejected' || status === 'Completed') {
    return true
  }
  return false
}

export const getInboundRequestStatus = (status) => { // 👈️ Get Inbound Request Status
  if (status !== "CREATED") {
    return true
  }
  return false
}

export const html2PdfDoc = (id, fileName) => { // 👈️ Convert HTML to PDF
  const htmlId = document.getElementById(id)
  const doc = new jsPDF()
  doc.html(htmlId, {
    callback(doc) {
      // Save the PDF
      doc.save(fileName)
    },
    x: 15,
    y: 15,
    width: 180, //target width in the PDF document
    windowWidth: htmlId.offsetWidth //window width in CSS pixels
  })
}

export const html2PdfReport = (id, fileName, width, height) => { // 👈️ Convert HTML to PDF
  //html2PdfDoc(id, fileName)
  if (height < width) {
    height = 900
  }
  const htmlId = document.getElementById(id)
  for (let i = 0; i < 2; i++) {
    html2canvas(htmlId).then((canvas) => {
      const imgData = canvas.toDataURL("image/png")
      const pdf = new jsPDF("p", "pt", [width, height], true)
      pdf.addImage(imgData, "PNG", 60, 25)
      if (i === 1) {
        pdf.save(fileName)
      }
    })
  }
}

export const html2Pdf = (id, fileName, size) => { // 👈️ Convert HTML to PDF
  const htmlId = document.getElementById(id)
  html2canvas(htmlId).then((canvas) => {
    const imgData = canvas.toDataURL("image/png")
    const pdf = new jsPDF("p", "pt", size)
    pdf.addImage(imgData, "JPEG", 60, 25)
    pdf.save(fileName)
  })
}

export const randomKeyGen = (min) => { // 👈️ Random Key For HTML elements
  const random = Math.floor(Math.random() * (100000000000000 - min + 1)) + min
  return random
}

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

// 👇 Builds the Ocean Booking hold label from holdDetails, e.g. "Hold-Transload", "Hold-Outgate", "Hold - Transload & Outgate"
export const getHoldLabel = (holdDetails) => {
  if (!holdDetails) return ''
  const { holdTransload, holdOutgate } = holdDetails
  if (holdTransload && holdOutgate) return 'Hold - Transload & Outgate'
  if (holdTransload) return 'Hold-Transload'
  if (holdOutgate) return 'Hold-Outgate'
  return ''
}

export const CopyText = ({ text }) => {
  const onCopy = () => {
    toast.success('Copied To Clipboard !')
  }
  return (
    <CopyToClipboard onCopy={onCopy} text={text}>
      <Copy size={14} style={{ cursor: 'pointer', color: 'GrayText' }} />
    </CopyToClipboard>
  )
}

export const isValidToken = async () => {
  const response = await axios.get(`${urlAuthService}/IsValidToken`)
  if (!response.data.success) {
    window.location = "/login"
  }
  return response
}

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => { // 👈️ Check User Logged In
  const token = localStorage.getItem('accessToken')
  const decodedToken = jwt_decode(token)
  const currentDate = new Date()
  // JWT exp is in seconds
  if (decodedToken.exp * 1000 < currentDate.getTime()) {
    localStorage.removeItem('userData')
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    window.location = "/login"
  } else {
    isValidToken()
    return true
  }
}

//get user role from token
export const getUserRole = () => { // 👈️ Get User Role
  const token = localStorage.getItem('accessToken')
  const decodedToken = jwt_decode(token)
  return decodedToken.role
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData')) // 👈️ getUserData from Local Storage

export const isExternalDispatch = () => {
  const roles = getUserRole()
  if (!roles) return false
  const normalize = r => r.toLowerCase().replace(/\s/g, '')
  if (Array.isArray(roles)) return roles.some(r => normalize(r) === 'externaldispatch')
  return normalize(roles) === 'externaldispatch'
}

//US 11866 - booking team roles may toggle the FF Order Active indicator
export const isBookingTeam = () => matchesBookingTeam(getUserRole())

export const getExternalDispatchCompanyCode = () => {
  const userData = getUserData()
  return userData?.companyCode || null
}

export const getUriParams = params => { // 👈️ Arrange URL Parameters
  // Build URI dynamically based on provided parameters
  const parts = []

  if (params.page !== undefined) parts.push(`page=${params.page}`)
  if (params.perPage !== undefined) parts.push(`perPage=${params.perPage}`)
  if (params.status !== undefined) parts.push(`status=${params.status}`)
  if (params.q !== undefined) parts.push(`q=${params.q}`)
  if (params.sort !== undefined) parts.push(`sort=${params.sort}`)
  if (params.sortColumn !== undefined) parts.push(`sortColumn=${params.sortColumn || ''}`)

  return parts.join('&')
}

export const getUserUriParams = params => { // 👈️ Arrange User URL Parameters
  const confirmed = `${(params.confirmed === null || params.confirmed === undefined) ? '' : '&confirmed=true'}`
  const role = (params.role === '' || params.role === null || params.role === undefined) ? '' : `&role=${params.role}`
  const department = (params.department === '' || params.department === null || params.department === undefined) ? '' : `&department=${params.department}`
  const q = (params.q === '' || params.q === null || params.q === undefined) ? '' : `&q=${params.q}`
  const status = (params.status === '' || params.status === null || params.status === undefined) ? '' : `&status=${params.status}`
  const companyCode = (params.companyCode === '' || params.companyCode === null || params.companyCode === undefined) ? '' : `&companyCode=${params.companyCode}`
  const employeeCode = (params.employeeCode === '' || params.employeeCode === null || params.employeeCode === undefined) ? '' : `&employeeCode=${params.employeeCode}`
  const uri = `page=${params.page}&perPage=${params.perPage}${status}${q}&sort=${params.sort}&sortColumn=${params.sortColumn}${department}${role}${confirmed}${companyCode}${employeeCode}`
  return uri
}

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => { // 👈️ Get Home Routes
  const loggedInUser = getUserRole()

  // External Dispatch users must always land on the External Dispatch page
  if (isExternalDispatch()) return ExternalDispatchRoute

  const lastVisitedPage = localStorage.getItem('currentPage') || null
  if (lastVisitedPage !== null) return lastVisitedPage
  if (loggedInUser?.indexOf('masteradmin') !== -1) return AdminDashboardRoute
  if (loggedInUser?.indexOf('admin') !== -1) return AdminDashboardRoute
  if (loggedInUser?.indexOf('logistics') !== -1) return DefaultRoute
  if (loggedInUser?.indexOf('hr') !== -1) return HRDashboardRoute
  if (loggedInUser?.indexOf('any') !== -1) return AnyDashboardRoute
  if (loggedInUser?.indexOf('limited') !== -1) return LimitedDashboardRoute
  //if (userRole === 'Employee') return DefaultRoute
  //if (userRole === 'Customer') return '/access-control'
  userRole = ''
  console.log(userRole)
  return '/login'
}


export const selectThemeColors = theme => ({ // 👈️ React Select Theme Colors
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#7367f01a', // for option hover bg-color
    primary: '#7367f0', // for selected option bg-color
    neutral10: '#7367f0', // for tags bg-color
    neutral20: '#ededed', // for input border-color
    neutral30: '#ededed' // for input hover border-color
  }
})

export const numberWithCommas = x => { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }

export const numberWithCommasPreservePrecision = value => {
  if (value === null || value === undefined) return value

  const stringValue = value.toString()
  const match = stringValue.match(/^(-?)(\d+)(\.\d+)?$/)

  if (!match) return stringValue

  const [, sign, integerPart, decimalPart = ''] = match

  return `${sign}${integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${decimalPart}`
}

export const AmountFormatter = ({ amount }) => { return isNaN(Number(amount)) ? 'isNaN' : `$ ${numberWithCommas(Number(amount).toFixed(2))}` }

export const RequiredSymbol = () => <span className='text-danger'>*</span>

export const MTtoKg = (mt) => { // 👈️ Convert Metric Ton to Kilogram
  const newWeight = numberWithCommas((mt * 1000).toFixed(2))
  return `${newWeight} Kg`
}

export function isValidISOContainerNumber(containerNumber) {
  return CheckContainerNumberPerIsoSD(containerNumber)
  // return isValidContainerNumber(containerNumber)// || CheckContainerNumberPerIsoSD(containerNumber)
}

export const removeEmptyFields = (obj) => {
  const newObj = {}
  for (const key in obj) {
    if (obj[key] !== "") {
      newObj[key] = obj[key]
    }
  }
  return newObj
}

export const GetSortedStatuses = (statuses) => {
  // Assuming 'statuses' is your array
  const sortedStatuses = [...statuses] // Create a copy of the array if necessary to avoid mutating the original array

  sortedStatuses.sort((a, b) => {
    // Convert the dates from string to Date objects for comparison
    const dateA = new Date(a.createdAt)
    const dateB = new Date(b.createdAt)

    return dateB - dateA // For descending order
  })

  // Now 'sortedStatuses' contains the statuses ordered by 'createdAt' in descending order
  return sortedStatuses
}
export function jsonToFormData(jsonObject, formData = new FormData(), parentKey = null) {
  Object.keys(jsonObject).forEach(key => {
    const fullPathKey = parentKey ? `${parentKey}[${key}]` : key
    if (jsonObject[key] instanceof File) {
      // Handle File object directly
      formData.append(fullPathKey, jsonObject[key])
    } else if (jsonObject[key] instanceof Object && !(jsonObject[key] instanceof Array)) {
      // Recurse into nested objects
      jsonToFormData(jsonObject[key], formData, fullPathKey)
    } else if (jsonObject[key] instanceof Array) {
      // Iterate through arrays
      jsonObject[key].forEach((item, index) => {
        if (typeof item === 'object' && !(item instanceof File)) {
          // Recurse into nested objects within arrays
          jsonToFormData(item, formData, `${fullPathKey}[${index}]`)
        } else {
          // Handle primitive types and File objects in arrays
          formData.append(`${fullPathKey}[]`, item)
        }
      })
    } else {
      // Handle primitive types
      formData.append(fullPathKey, jsonObject[key])
    }
  })
  return formData
}

// Function to calculate cargo weight
export const calculateCargoWeight = (item) => {
  // Checks if cargoType is either: Tote, Bag, or Pallet
  if (item.cargoType === 'TT' || item.cargoType === 'BAG' || item.cargoType === 'PLT') {
    // Multiplies cargoAmount by packageWeight and converts to KG (depending on unit)
    return item.cargoAmount * item.packageWeight * ((item.weightUnit === 'LBS') ? 0.453592 : (item.weightUnit === 'MT' ? 1000 : 1))
  } else {
    return item.packageWeight
  }
}

export const imgToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result.split('base64,')[1])
    reader.onerror = error => reject(error)
  })
}

export const stringToCommaseparated = (str) => {
  if (str === null || str === undefined || str === '' || str?.length === 0) return []
  return str?.split(',')?.map(el => el.trim())?.filter(item => item !== '') || []
}

export const excelTemplate = async (store, headers, headerValues, name) => {
  const dataArray = Array.isArray(store) ? store : store.data || []

  async function dataFormater(dataArray) {
    const formattedData = []

    const filterDataHeaders = store.filter ? Object.entries(store.filter).reduce((result, [key, value]) => {
      if (value && value !== null) {
        let formattedKey = key.replace(/([A-Z])/g, " $1").toLowerCase().trim()
        formattedKey = formattedKey.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
        result.push(formattedKey)
      }
      return result
    }, []) : []

    const filterDataValues = store.filter ? Object.entries(store.filter).reduce((result, [, value]) => {
      if (value) {
        if (typeof value === 'string') {
          let formattedValue = value.toLowerCase()
          formattedValue = formattedValue.charAt(0).toUpperCase() + formattedValue.slice(1)
          formattedValue = formattedValue.replace(/([A-Z])/g, " $1").trim()
          result.push(formattedValue)
        } else {
          result.push(value)
        }
      }
      return result
    }, []) : []

    formattedData.push([])
    formattedData.push([])
    formattedData.push(filterDataHeaders)
    formattedData.push(filterDataValues)
    formattedData.push([])
    formattedData.push(headers)

    dataArray.forEach(obj => {
      const values = headerValues?.map(headerValue => {
        let value
        if (typeof headerValue === 'string') {
          if (headerValue.includes('.')) {
            value = headerValue.split('.').reduce((o, k) => (o || {})[k], obj)
          } else {
            value = obj[headerValue]
          }
        } else {
          value = headerValue(obj)
        }
        // Apply date-only formatting for createdAt and lastModified (only for string property names, not functions)
        if (typeof headerValue === 'string' && (headerValue === 'createdDate' || headerValue === 'lastModifiedDate' || headerValue.includes("Date"))) {
          return getLocalDateOnly(value, "T")
        }

        if (typeof value === 'string') {
          const iso8601Format = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/
          if (iso8601Format.test(value)) {
            const date = new Date(value)
            if (!isNaN(date.getTime())) {
              return formatDate(date)
            }
          }
        }

        return value
      })
      formattedData.push(values)
    })

    return formattedData
  }

  const finalData = await dataFormater(dataArray)

  function customFormatDate(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')
    return `${year}-${month}-${day}_${hours}:${minutes}:${seconds}`
  }

  const date = new Date()
  const formattedDate = customFormatDate(date)
  const fileName = `${name}-${formattedDate}`

  console.log(fileName)

  const workbook = new ExcelJS.Workbook()

  const response = await fetch('https://shipsmpl20st.blob.core.windows.net/store-receipts-test/image002.png')
  if (!response.ok) throw new Error('Network response was not ok')

  const imageBlob = await response.blob()
  const arrayBuffer = await imageBlob.arrayBuffer()
  const imageBuffer = Buffer.from(arrayBuffer)
  const imageId = workbook.addImage({ buffer: imageBuffer, extension: 'png' })

  const worksheet = workbook.addWorksheet(fileName.includes('_') ? fileName.split('_')[0] : fileName)
  finalData.forEach((row, rowIndex) => {
    const excelRow = worksheet.addRow(row)

    if (rowIndex === 0) {
      excelRow.height = 50
      worksheet.addImage(imageId, {
        tl: { col: 0, row: 0 },
        ext: { width: 3.55 * 96 / 2.54, height: 1.72 * 96 / 2.54 }
      })
      worksheet.getCell('B1').value = name
      worksheet.mergeCells('B1:C1')
      worksheet.getCell('D1').value = getLocalDateOnly(new Date(), "T")
    }

    excelRow.eachCell((cell, cellNumber) => {
      cell.alignment = { horizontal: 'center' }
      cell.font = cell.font || {}
      cell.font = { name: 'Aptos Narrow', size: 12 }

      const value = cell.value
      if (typeof value === 'string') {
        const datePattern = /^\w{3} \w{3} \d{2} \d{4} \d{2}:\d{2}:\d{2} GMT-\d{4} \(\w+ \w+ \w+\)$/
        if (datePattern.test(value)) {
          const date = new Date(value)
          if (!isNaN(date.getTime())) {
            cell.value = customFormatDate(date)
          }
        }
      }

      if (rowIndex === 0 && cellNumber === 3) {
        const cell = worksheet.getCell('B1')
        cell.font = { name: 'Aptos Narrow', bold: true, size: 20 }
        cell.alignment = { horizontal: 'left' }
      }

      if (rowIndex === 2 || rowIndex === 5) {
        cell.font = { bold: true, color: { argb: 'FFFFFFFF' } }
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF000000' } }
      }

      if (rowIndex === 2 || rowIndex === 3) {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }
      }
    })
  })
  
  worksheet.columns = Array(40).fill({ width: 15 })

  // // Set column widths dynamically based on header content
  // worksheet.columns = headers.map(header => {
  //   const headerLength = header ? header.toString().length : 10
  //   // Set width with min of 10 and max of 50, with a multiplier for character width
  //   const width = Math.min(Math.max(headerLength * 1.2, 10), 50)
  //   return { width }
  // })

  // // Set column widths dynamically based on header content
  // worksheet.columns = headers.map(header => {
  //   const headerLength = header ? header.toString().length : 10
  //   // Set width with min of 10 and max of 50, with a multiplier for character width
  //   const width = Math.min(Math.max(headerLength * 1.2, 10), 50)
  //   return { width }
  // })

  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
  const downloadLink = document.createElement('a')
  downloadLink.href = URL.createObjectURL(blob)
  downloadLink.download = fileName
  document.body.appendChild(downloadLink)
  downloadLink.click()
  document.body.removeChild(downloadLink)
}

export const formatImageName = (listOfTags, pictureName) => {
  const pictureExtension = pictureName.split('.').pop()
  const pictureTags = listOfTags.join('_')
  return `${pictureTags}.${pictureExtension}`
}

export const customFormatDate = () => {
  const date = new Date()
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}_${month}_${day}`
}

export const excelReportHeader = (worksheet, data, rowIndex) => {
  const setCellValue = (cell, value, fontSize) => {
    worksheet.getCell(cell).value = value
    worksheet.getCell(cell).font = { bold: true, ...(fontSize && { size: fontSize }) }
  }

  const applyPerimeterBorders = (startRow, endRow) => {
    for (let i = startRow; i <= endRow; i++) {
      const borders = {
        A: { left: { style: 'thin' }, ...(i === startRow && { top: { style: 'thin' } }), ...(i === endRow && { bottom: { style: 'thin' } }) },
        F: { right: { style: 'thin' }, ...(i === startRow && { top: { style: 'thin' } }), ...(i === endRow && { bottom: { style: 'thin' } }) }
      }
      worksheet.getCell(`A${i}`).border = borders.A
      worksheet.getCell(`F${i}`).border = borders.F
      for (let j = 2; j <= 5; j++) {
        worksheet.getCell(`${String.fromCharCode(64 + j)}${i}`).border = {
          ...(i === startRow && { top: { style: 'thin' } }),
          ...(i === endRow && { bottom: { style: 'thin' } })
        }
      }
    }
  }

  const rows = [
    { index: 2, cells: [['A3', 'Customer:', 11], ['B3', data?.customer, 12], ['C3', 'Shipper', 11], ['D3', data?.shipper, 12], ['E3', 'Customer Ref #:', 11], ['F3', data?.customerReference, 12]], height: 34 / 1.33 },
    { index: 3, cells: [['A4', 'Forwarder:', 11], ['B4', data?.oceanBooking?.forwarder, 12], ['C4', 'WTC Order #:', 11], ['D4', data?.transloadOrderNumber, 12], ['E4', 'Shipper Ref:', 11], ['F4', data?.shipperReference, 12]], height: 34 / 1.33 },
    { index: 4, cells: [['A5', 'Booking:', 11], ['B5', data?.oceanBooking?.bookingNumber, 12], ['C5', 'Origin', 11], ['D5', data?.oceanBooking?.origin, 12], ['E5', 'L.R.D.:', 11], ['F5', data?.oceanBooking?.vesselVoyage?.latestReceivingDate && getLocalDateOnly(data?.oceanBooking?.vesselVoyage?.latestReceivingDate, 'T')]], height: 34 / 1.33 },
    { index: 5, cells: [['A6', 'Vessel/Voyage:', 11], ['B6', `${data?.oceanBooking?.vesselVoyage?.vesselName}${data?.oceanBooking?.vesselVoyage?.number ? ` / ${data?.oceanBooking?.vesselVoyage?.number}` : ''}`, 12], ['C6', 'Destination:', 11], ['D6', data?.oceanBooking?.destination, 12], ['E6', 'E.T.D.:', 11], ['F6', data.oceanBooking?.vesselVoyage?.estimatedTimeOfDeparture && getLocalDateOnly(data.oceanBooking?.vesselVoyage?.estimatedTimeOfDeparture, 'T')]], height: 34 / 1.33 },
      { index: 6, cells: [['A7', 'Line', 11], ['B7', data?.oceanBooking?.shippingLineCode, 12], ['C7', 'Delivered To:', 11], ['D7', data?.oceanBooking?.vesselVoyage?.terminalName, 12], ['E7', 'Transload Service:', 11], ['F7', data?.transloadType?.length > 0 ? data.transloadType.join(', ') : 'N/A', 12]], height: 34 / 1.33 },
    { index: 7, cells: [['A8', `Total Equipment: ${data?.totalEquipmentCount || 0}`, null, 12], ['B8', `Empty: ${data?.totalEmptyEquipment || 0}`, null, 12], ['C8', `Outstanding: ${data?.totalOutStandingEquipment || 0}`, null, 12], ['D8', `Partially Loaded: ${data?.totalPartialEquipment || 0}`, null, 12], ['E8', `Loaded: ${data?.totalLoadedEquipment || 0}`, null, 12], ['F8', `Delivered: ${data?.totalDeliveredEquipment || 0}`, null, 12]], height: 34 / 1.33, fillColor: 'D9D9D9' }
  ]

  rows.forEach(row => {
    if (rowIndex === row.index) {
      worksheet.getRow(row.index + 1).height = row.height
      row.cells.forEach(([cell, value, fontSize]) => setCellValue(cell, value, fontSize))
      if (row.fillColor) {
        for (let i = 1; i <= 6; i++) {
          worksheet.getCell(`${String.fromCharCode(64 + i)}8`).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: row.fillColor }
          }
        }
      }
    }
  })

  if (rowIndex === 7) {
    applyPerimeterBorders(3, 5)
    applyPerimeterBorders(6, 7)
    applyPerimeterBorders(8, 8)
  }
}
//header for nova excel report
export const novaExcelReportHeader = (worksheet, data, rowIndex) => {
  const setCellValueAndMerge = (cell, value, fontSize) => {
    worksheet.getCell(cell).value = value
    worksheet.getCell(cell).font = { bold: true, ...(fontSize && { size: fontSize }) }
  }

  const applyPerimeterBorders = (startRow, endRow) => {
    for (let i = startRow; i <= endRow; i++) {
      for (let j = 1; j <= 2; j++) {
        worksheet.getCell(`${String.fromCharCode(64 + j)}${i}`).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' },
          bottom: { style: 'thin' }
        }
      }
    }
  }

  const rows = []

  // Conditionally add PO Number row if poNumber exists
  if (data[0]?.poNumber) {
    rows.push({
      index: 2,
      cells: [['A3', 'PO Number:', null, 12], ['B3', data[0]?.poNumber, 'B3:D3', 18]], // Fix the merge range
      height: 34 / 1.33
    })
  }

  // Conditionally add vessel name if vesselName exists
  if (data[0]?.vesselName) {
    rows.push({
      index: 3,
      cells: [['A4', 'Vessel Name:', null, 12], ['B4', data[0]?.vesselName, 'B4:D4', 14]], // Fix the merge range
      height: 34 / 1.33
    })
  }

  // Conditionally add voyage number if voyageNumber exists
  if (data[0]?.voyageNumber) {
    rows.push({
      index: 4,
      cells: [['A5', 'Voyage Number:', null, 12], ['B5', data[0]?.voyageNumber, 'B5:D5', 14]], // Fix the merge range
      height: 34 / 1.33
    })
  }

  // Conditionally add Billing Period row if billingPeriod exists
  if (data[0]?.billingPeriod) {
    rows.push({
      index: 5,
      cells: [['A6', 'Billing Period:', null, 12], ['B6', data[0]?.billingPeriod, 'B6:D6', 14]], // Fix the merge range and row index
      height: 34 / 1.33
    })
  }

  // Add Customer row
  rows.push({
    index: 6,
    cells: [['A7', 'Customer:', null, 12], ['B7', data[0]?.customer || data?.customer, 'B7:D7', 14]], // Fix the merge range and row index
    height: 34 / 1.33
  })

  // Iterate over rows and apply the cell values, merging, and heights
  rows.forEach(row => {
    if (rowIndex === row.index) {
      worksheet.getRow(row.index + 1).height = row.height
      row.cells.forEach(([cell, value, mergeRange, fontSize]) => setCellValueAndMerge(cell, value, mergeRange, fontSize))
    }
  })

  // Apply perimeter borders for certain rows
  if (rowIndex === 7) {
    applyPerimeterBorders(3, 7) // Ensure proper border range for the rows that are being displayed
  }
}

export const findAvailableEmpty = (depot, yardLocation, equipmentSize, shippingLine) => {
  const matches = depot.filter(d => (yardLocation ? d.yardLocation === yardLocation : true) &&
    d.equipmentSize === equipmentSize &&
    d.shippingLine === shippingLine
  )
  const totalAvailableEmpty = matches.reduce((sum, match) => sum + match.availableEmpty, 0)
  return matches.length > 0 ? totalAvailableEmpty : 0
}
